// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA6AmMw3mFopjrL85WEMspOSo5Mn-RNC0c",
  authDomain: "shreraksha-2820d.firebaseapp.com",
  projectId: "shreraksha-2820d",
  storageBucket: "shreraksha-2820d.firebasestorage.app",
  messagingSenderId: "914767820767",
  appId: "1:914767820767:web:5754e1823c0320b252b66a",
  measurementId: "G-Y0PKJJPTTS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export const storage = getStorage(app);

export default app;